import React, { Fragment, useState } from 'react'
import leadFormFields from "../../../assets/data/leadForm.json"
import state_city from "../../../assets/data/state_city.json"
import "./leadform.css"
import common from '../../../methods/common';
import Dropdown from '../../../coreComponents/dropdown/Dropdown';


const LeadForm = (props) => {
    let { data, updatedata, submit } = props;
    const [err, setError] = useState("")


    let fields = leadFormFields;
    console.log(state_city)
    let statesData = state_city.states.map(state=>({...state, key:state.name, value:state.name}))

    const checkValidation = () => {
        if (!data.quotation_date) {
            setError("Please enter date.");
            return false;
        }
        if (!data.quantity || data.quantity<0) {
            setError("Please enter quantity of guns.");
            return false;
        }
        if (!data.price) {
            setError("Please enter price of one gun.");
            return false;
        }
        if (data.price< 160000) {
            setError("Gun price can not be less than INR. 1,60,000");
            return false;
        }
        if(data.company_mobile && data.company_mobile.length !==10){
            setError("Company Mobile Number must be 10 digits");
            return false;
        }
        if(data.contact_person_mobile && data.contact_person_mobile.length !==10){
            setError("Contact Person Mobile Number must be 10 digits");
            return false;
        }
        if(data.company_email && !common.checkvalidEmail(data.company_email)){
            setError("Company Email must be valid email address");
            return false;
        }
        if(data.contact_person_email && !common.checkvalidEmail(data.contact_person_email)){
            setError("Contact Person Email must be valid email address");
            return false;
        }
        return true;
    }
    const childSubmit=()=>{
        if(checkValidation()){
            submit()
        } else{
            // setError
        }
    }

    const changehandle = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if(name.includes("mobile")){
            if( value.length <11){
                updatedata({ [name]: value })
            } else{
                return
            }
        } else{
            updatedata({ [name]: value })
        }

    }
    const getCityArr=()=>{
        let obj = state_city.states.find(item=>item.name === data.state)
        if(obj){
            let cityArr = state_city.districts[`${obj.id}`]
            cityArr = cityArr.map(city =>({...city, key:city.name,value:city.name}))
            return cityArr
        } else return []
    }
    console.log(state_city)
    const selectHandle = (key, val)=>{
        if(key==='state'){
            updatedata({ [key]: val })
            updatedata({ "city": "" })
        } else{
            updatedata({ [key]: val })
        }
    }
    const renderStateCity = () => {
        let stateProps =  {
            lableProps: {
                id: "state",
                label: "Select State",
                name: "State",
            },
            items: statesData,
            selectHandle: selectHandle,
        }
        let cityProps =  {
            lableProps: {
                id: "city",
                label: "Select City",
                name: "City",
            },
            items: getCityArr(),
            selectHandle: selectHandle,
        }
        return <div className="group">
            <Dropdown propsData={stateProps}/>
            {data.state && <Dropdown propsData={cityProps}/>}
        </div>
    }


    return (
        <div>
            {/* {fields.map(item=>{
                return <div>
                    <input type={item.type} placeholder={item.place_holder} />
                </div>
            })} */}

            <div class="login-wrap">
                <div class="login-html">
                    <input id="tab-1" type="radio" name="tab" class="sign-in" checked /><label for="tab-1" class="tab">Quotation Details</label>
                    <input id="tab-2" type="radio" name="tab" class="sign-up" /><label for="tab-2" class="tab"></label>
                    <div class="login-form">
                        <div className="sign-in-htm">
                            {fields.map(item => {
                                return (
                                    <Fragment>
                                        {item.key==="company_address"?<div>
                                            {renderStateCity()}
                                        </div>:null}
                                        <div className="group">
                                            {/* <label for={item.key} className="label">Username</label> */}
                                            <input value={data[item.key]} id={item.key} name={item.key} type={item.type} className="input" placeholder={item.place_holder} onChange={changehandle} />
                                        </div>
                                    </Fragment>
                                )
                            })}
                            <div className="group">
                                <input onChange={changehandle} name='quotation_date' id="quotation_date" type="date" className="input black-bg" value={data["quotation_date"]} placeholder='Date'/>
                            </div>
                            <div className="group">
                                <input type="submit" className="button pointer" value="Generate Quotation"  onClick={childSubmit}/>
                            </div>
                            {err?<div className='error'>{err}</div>:null}
                            <div className="hr"></div>
                            <div className="foot-lnk">
                                <a href="#forgot">These details will be printed on the quotation.</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default LeadForm